module.exports = __webpack_public_path__ + "img/pr-10.bdb04533.png";